import { callBackendFunction } from "./paymentService";

export interface SubscribeToWaitlistPayload {
  outingId: string;
  displayName: string;
  email: string;
  notifyByEmail: boolean;
  notifyByPush: boolean;
  consent: {
    granted: boolean;
    textVersion?: string;
    source?: string;
  };
}

export interface SubscribeToWaitlistResponse {
  ok: boolean;
  status: "subscribed" | "already_subscribed";
  alreadySubscribed?: boolean;
  entryId?: string;
}

export interface UnsubscribeFromWaitlistPayload {
  outingId: string;
  entryId?: string;
  email?: string;
}

export interface UnsubscribeFromWaitlistResponse {
  ok: boolean;
  status: "unsubscribed" | "already_unsubscribed";
  idempotent?: boolean;
  entryId?: string;
}

export async function subscribeToWaitlist(
  payload: SubscribeToWaitlistPayload
): Promise<SubscribeToWaitlistResponse> {
  return callBackendFunction<SubscribeToWaitlistPayload, SubscribeToWaitlistResponse>(
    "subscribeToWaitlist",
    payload
  );
}

export async function unsubscribeFromWaitlist(
  payload: UnsubscribeFromWaitlistPayload
): Promise<UnsubscribeFromWaitlistResponse> {
  return callBackendFunction<UnsubscribeFromWaitlistPayload, UnsubscribeFromWaitlistResponse>(
    "unsubscribeFromWaitlist",
    payload
  );
}
